import React from 'react';
import { CardWrapper } from './styles';
import { Button } from 'antd';
import { t } from 'i18next';
import ConfirmModal from '../components/Modal/ConfirmModal';
import RejectReason from '../components/Modal/RejectReason';
import { useDispatch } from '@redux';
import crudActions from '@redux/crudActions';

const Validation = () => {
  const dispatch = useDispatch();

  const handleRejectModal = (value) => {
    dispatch(
      crudActions.modal.toogleModal({
        ['reject']: {
          isOpen: value,
        },
      } as any),
    );
  };

  const handleConfirmModal = (value) => {
    dispatch(
      crudActions.modal.toogleModal({
        ['confirm']: {
          isOpen: value,
        },
      } as any),
    );
  };

  return (
    <CardWrapper title="Validation">
      <div className="flex gap-5 w-full">
        <Button
          className="w-full h-[40px]"
          onClick={() => handleRejectModal(true)}
        >
          {t('button.reject')}
        </Button>
        <Button
          type="primary"
          className="w-full h-[40px]"
          onClick={() => handleConfirmModal(true)}
        >
          {t('button.confirm')}
        </Button>
      </div>
      <ConfirmModal onCancel={() => handleConfirmModal(false)} />
      <RejectReason onCancel={() => handleRejectModal(false)} />
    </CardWrapper>
  );
};

export default Validation;
